import { Calendar } from '@fullcalendar/core';
import ResourceApi from './api/ResourceApi';
import { parseResource } from './structs/resource';
Calendar.prototype.addResource = function (input, scrollTo) {
    var _a;
    if (scrollTo === void 0) { scrollTo = true; }
    var resourceHash;
    var resource;
    if (input instanceof ResourceApi) {
        resource = input._resource;
        resourceHash = (_a = {}, _a[resource.id] = resource, _a);
    }
    else {
        resourceHash = {};
        resource = parseResource(input, '', resourceHash, this);
    }
    // HACK
    if (scrollTo) {
        this.component.view.addScroll({ forcedRowId: resource.id });
    }
    this.dispatch({
        type: 'ADD_RESOURCE',
        resourceHash: resourceHash
    });
    return new ResourceApi(this, resource);
};
Calendar.prototype.getResourceById = function (id) {
    id = String(id);
    if (this.state.resourceStore) { // guard against calendar with no resource functionality
        var rawResource = this.state.resourceStore[id];
        if (rawResource) {
            return new ResourceApi(this, rawResource);
        }
    }
    return null;
};
Calendar.prototype.getResources = function () {
    var resourceStore = this.state.resourceStore;
    var resourceApis = [];
    if (resourceStore) { // guard against calendar with no resource functionality
        for (var resourceId in resourceStore) {
            resourceApis.push(new ResourceApi(this, resourceStore[resourceId]));
        }
    }
    return resourceApis;
};
Calendar.prototype.getTopLevelResources = function () {
    var resourceStore = this.state.resourceStore;
    var resourceApis = [];
    if (resourceStore) { // guard against calendar with no resource functionality
        for (var resourceId in resourceStore) {
            if (!resourceStore[resourceId].parentId) {
                resourceApis.push(new ResourceApi(this, resourceStore[resourceId]));
            }
        }
    }
    return resourceApis;
};
Calendar.prototype.rerenderResources = function () {
    this.dispatch({
        type: 'RESET_RESOURCES'
    });
};
Calendar.prototype.refetchResources = function () {
    this.dispatch({
        type: 'REFETCH_RESOURCES'
    });
};
export function transformDatePoint(dateSpan, calendar) {
    return dateSpan.resourceId ?
        { resource: calendar.getResourceById(dateSpan.resourceId) } :
        {};
}
export function transformDateSpan(dateSpan, calendar) {
    return dateSpan.resourceId ?
        { resource: calendar.getResourceById(dateSpan.resourceId) } :
        {};
}
